// @flow

import 'core-js/es6'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './store/index'
import App from './app'
import { unregister } from './registerServiceWorker'

const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('Elemento root non presente')
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  rootElement
)
unregister()



// WEBPACK FOOTER //
// ./src/index.js